<template>
  <component :is="dynamicIcon"/>
</template>

<script>
  export default {
    name: 'DynamicIcon',
    props: {
      icon: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        iconName: ''
      }
    },
    created() {
      this.iconName = this.icon;
    },
    watch: {
      icon(newVal) {
        this.iconName = newVal;
      }
    },
    computed: {
      dynamicIcon () {
        let iconName = this.iconName;
        return () => {
          return import(
            `../../assets/images/svg/${iconName}.svg`
            )
        }
      },
    },
  }
</script>
